import { lazy, Suspense } from 'react';
import type { CodeMirrorEditorProps } from './CodeMirrorEditor';

const CodeMirrorEditor = lazy(() => import('./CodeMirrorEditor'));

/** Lazy boundary so CodeMirror is code-split and only loaded on first edit. */
export function Editor(props: CodeMirrorEditorProps) {
  return (
    <Suspense
      fallback={<div className="h-full p-4 text-sm text-neutral-500">Loading editor…</div>}
    >
      <CodeMirrorEditor {...props} />
    </Suspense>
  );
}
